(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtf-buy-steps"] && !Shopify.designMode) return;
  try {
    
/* Step chrome for dtf-buy-steps. Everything that draws, prices or gates lives
   in the FitCheck engine (dtf-sections.js) and is untouched; this only decides
   which step is open, writes the folded summaries, composes the one-line status
   from the engine's readout, and — with no product set — prices the quote. */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-bsteps]').forEach(function (root) {
      if (root.dataset.bstepsReady) return;
      root.dataset.bstepsReady = '1';
      setup(root);
    });
  }

  function setup(root) {
    var q = function (s) { return root.querySelector(s); };
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-bstep]'));
    // steps are addressed by kind, not position, so the order in the markup can change
    var kinds = steps.map(function (s) { return s.getAttribute('data-bstep'); });
    var at = function (kind) { return kinds.indexOf(kind); };
    var canOrder = root.dataset.canOrder === '1';
    var msgs = {
      none: root.dataset.msgNone || 'Upload your artwork to check print quality.',
      good: root.dataset.msgGood || 'Good to print',
      ok: root.dataset.msgOk || 'Usable, though not ideal at this size',
      bad: root.dataset.msgBad || 'Too low to print well at this size',
      big: root.dataset.msgOversize || ''
    };

    var fileRow = q('[data-dtf-fit-filerow]'), fileName = q('[data-dtf-fit-filename]');
    var fileIn = q('[data-dtf-fit-file]'), alphaOut = q('[data-dtf-fit-alpha]');
    var sizeSel = q('[data-dtf-fit-sizes]'), inW = q('[data-dtf-fit-w]'), inH = q('[data-dtf-fit-h]');
    var oSize = q('[data-dtf-fit-size]'), oDpi = q('[data-dtf-fit-dpi]'), oNote = q('[data-dtf-fit-note]');
    var qtyIn = q('[data-dtf-fit-qty]'), eachOut = q('[data-dtf-fit-each]'), totalOut = q('[data-dtf-fit-total]');
    var tierWrap = q('[data-dtf-fit-tiers]'), nudge = q('[data-bstep-nudge]');
    var garmentSel = q('[data-bstep-garment]'), notes = q('[data-bstep-notes]');
    var stat = q('[data-bstat]'), statText = q('[data-bstat-text]');
    var infoBtn = q('[data-bstat-info]'), moreOut = q('[data-bstat-more]');
    if (infoBtn && moreOut) infoBtn.addEventListener('click', function () {
      var open = moreOut.hidden;
      moreOut.hidden = !open;
      infoBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var customBtn = q('[data-bstep-custom]'), dims = customBtn ? document.getElementById(customBtn.getAttribute('aria-controls')) : null;

    var setText = function (el, v) { if (el && el.textContent !== v) el.textContent = v; };
    var parse = function (s, fb) { try { return JSON.parse(s || ''); } catch (e) { return fb; } };
    var sizes = parse(sizeSel ? sizeSel.dataset.dtfFitSizes : '', []);
    var tiers = parse(tierWrap ? tierWrap.dataset.dtfFitTiers : '', []);
    var tiersLive = !!(tierWrap && tierWrap.dataset.tiersActive === 'true');
    var visited = steps.map(function (s, i) { return i === 0; });

    var hasArt = function () { return !!(fileRow && !fileRow.hidden); };
    var bdIns = Array.prototype.slice.call(root.querySelectorAll('[data-dtf-fit-bd]'));
    var qty = function () {
      if (bdIns.length) return bdIns.reduce(function (t, el) { var n = parseInt(el.value, 10); return t + (isFinite(n) && n > 0 ? n : 0); }, 0);
      var v = qtyIn ? parseInt(qtyIn.value, 10) : 1, min = qtyIn ? (parseInt(qtyIn.min, 10) || 1) : 1;
      return (!isFinite(v) || v < min) ? min : v;
    };
    var toNum = function (t) {
      var m = String(t == null ? '' : t).replace(/[^\d.,]/g, '');
      var c = m.lastIndexOf(',') > m.lastIndexOf('.') ? m.replace(/\./g, '').replace(',', '.') : m.replace(/,/g, '');
      var n = parseFloat(c); return isFinite(n) ? n : null;
    };
    var fmtLike = function (sample, n) {
      var sym = String(sample || '').replace(/[\d.,\s]/g, '') || 'R';
      var p = n.toFixed(2).split('.'), w = p[0], out = '', k = 0;
      for (var i = w.length - 1; i >= 0; i--) { out = w[i] + out; if (++k % 3 === 0 && i > 0) out = ',' + out; }
      return sym + out + '.' + p[1];
    };
    var tierFor = function (n) {
      var hit = null;
      tiers.forEach(function (t) { var m = parseInt(t.min, 10); if (isFinite(m) && n >= m && (!hit || m > parseInt(hit.min, 10))) hit = t; });
      return hit;
    };
    var nextTier = function (n) {
      var nx = null;
      // a tier with no discount is not something to aim for ("order 10+ and pay the normal price")
      tiers.forEach(function (t) { var m = parseInt(t.min, 10); if (t.off && isFinite(m) && m > n && (!nx || m < parseInt(nx.min, 10))) nx = t; });
      return nx;
    };

    /* ---- open / fold ---- */
    function open(i) {
      steps.forEach(function (s, k) {
        var on = k === i;
        if (on) s.setAttribute('data-open', ''); else s.removeAttribute('data-open');
        var hd = s.querySelector('.dtf-bstep__hd'); if (hd) hd.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (k < i) visited[k] = true;
      });
      visited[i] = true;
      sums();
    }
    steps.forEach(function (s, i) {
      var hd = s.querySelector('.dtf-bstep__hd'); if (hd) hd.addEventListener('click', function () { open(i); });
      var nx = s.querySelector('[data-bstep-next]'); if (nx) nx.addEventListener('click', function () { open(Math.min(i + 1, steps.length - 1)); });
    });

    /* ---- summaries and done-marks ---- */
    function sizeLabel() {
      if (dims && !dims.hidden && inW && inH && inW.value && inH.value) return inW.value + ' × ' + inH.value + ' mm';
      if (sizeSel && sizeSel.selectedIndex >= 0) {
        var item = sizes[parseInt(sizeSel.value, 10)];
        if (item) return (item.label || '') + (item.w && item.h ? ' · ' + item.w + ' × ' + item.h + ' mm' : '');
        return sizeSel.options[sizeSel.selectedIndex].textContent.trim();
      }
      return '';
    }
    function sums() {
      var n = qty(), t = tierFor(n);
      var g = garmentSel ? garmentSel.value : '';
      var S = {}, D = {};
      S.art = hasArt() ? ((fileName && fileName.textContent.trim()) || '') + (alphaOut && !alphaOut.hidden && !alphaOut.classList.contains('is-warn') && !alphaOut.classList.contains('is-note') ? ' · ' + alphaOut.textContent.trim() : '')
                       : (root.dataset.sumNofile || 'No file yet');
      S.size = sizeLabel();
      S.qty = n + ' ' + (root.dataset.sumTransfers || 'transfers') + (t && t.off ? ' · ' + t.off : '');
      S.details = ((g || (garmentSel ? (root.dataset.sumNoguarment || 'Garment colour not set') : '')) +
                   (notes && notes.value.trim() ? (g || !garmentSel ? ' · ' : '') + (root.dataset.sumNotes || 'notes added') : '')).replace(/^ · /, '');
      D.art = hasArt(); D.size = visited[at('size')]; D.qty = visited[at('qty')]; D.details = garmentSel ? !!g : visited[at('details')];
      steps.forEach(function (s, k) {
        var kind = kinds[k];
        setText(s.querySelector('[data-bstep-sum]'), S[kind] || '');
        var done = !!D[kind];
        if (done !== s.hasAttribute('data-done')) { if (done) s.setAttribute('data-done', ''); else s.removeAttribute('data-done'); }
      });
    }

    /* ---- status line: composed from the engine's readout ---- */
    function status() {
      if (!stat || !statText) return;
      if (!hasArt()) {
        if (stat.dataset.state !== 'none') stat.dataset.state = 'none';
        setText(statText, msgs.none);
        if (infoBtn && !infoBtn.hidden) { infoBtn.hidden = true; infoBtn.setAttribute('aria-expanded', 'false'); }
        if (moreOut && !moreOut.hidden) moreOut.hidden = true;
        return;
      }
      var note = oNote ? oNote.textContent.trim() : '';
      var dpi = oDpi ? oDpi.textContent.trim() : '';
      var state = 'good';
      /* The engine's note is a full sentence that opens with the verdict, so an
         exact match never fired and a weak file sat behind a green dot. */
      var starts = function (m) { return !!m && note.indexOf(m) === 0; };
      if (starts(msgs.bad) || (msgs.big && note.indexOf(msgs.big) >= 0) || (oDpi && oDpi.classList.contains('is-fail'))) state = 'bad';
      else if (starts(msgs.ok)) state = 'ok';
      /* Short line: verdict, dpi, and what to do. The engine's full sentence
         (numbers, pixel widths, the fix) was the whole status line and read as
         a paragraph (client, 16 Sep 2026), so it sits behind the info button. */
      var verdict = starts(msgs.bad) ? msgs.bad : starts(msgs.ok) ? msgs.ok : starts(msgs.good) ? msgs.good : '';
      var big = !!(msgs.big && note.indexOf(msgs.big) >= 0);
      var parts = [];
      if (verdict) parts.push(verdict); else if (big) parts.push(msgs.big);
      // the readout sets "180<small>dpi</small>", which reads back as "180dpi"
      if (dpi && dpi !== '—') parts.push(dpi.replace(/(\d)\s*dpi$/i, '$1 dpi'));
      // only when resolution is the problem, not when the size is simply too big for the garment
      var lowRes = starts(msgs.ok) || starts(msgs.bad) || !!(oDpi && oDpi.classList.contains('is-fail'));
      if (lowRes && root.dataset.msgHigherRes) parts.push(root.dataset.msgHigherRes);
      if (stat.dataset.state !== state) stat.dataset.state = state;
      setText(statText, parts.join(' · '));
      if (infoBtn && moreOut) {
        setText(moreOut, note);
        if (infoBtn.hidden !== !note) infoBtn.hidden = !note;
        if (!note && !moreOut.hidden) { moreOut.hidden = true; infoBtn.setAttribute('aria-expanded', 'false'); }
      }
    }

    /* ---- quote mode pricing: no product, so price the size block + tiers ---- */
    function quote() {
      if (canOrder) return;
      var item = sizes[parseInt(sizeSel ? sizeSel.value : '0', 10)] || sizes[0] || {};
      var n = qty(), t = tierFor(n);
      if (tierWrap) tierWrap.querySelectorAll('[data-dtf-fit-tier-row]').forEach(function (row) {
        var on = !!t && row.dataset.dtfFitTierRow === String(t.min);
        if (row.classList.contains('is-on') !== on) row.classList.toggle('is-on', on);
      });
      var base = item.price ? toNum(item.price) : null;
      var each = (tiersLive && t) ? toNum(t.each) : base;
      if (each == null) {
        setText(eachOut, root.dataset.quoteLabel || 'Priced on quote');
        setText(totalOut, '');
        return;
      }
      var sample = item.price || (t && t.each) || 'R';
      setText(eachOut, fmtLike(sample, each) + ' /ea');
      setText(totalOut, fmtLike(sample, each * n));
    }
    function nudgeLine() {
      if (!nudge || !tiers.length) return;
      var n = qty(), nx = nextTier(n);
      // nothing picked yet: no price talk until there is a quantity to talk about
      if (bdIns.length && n === 0) { setText(nudge, ''); return; }
      if (!nx) { setText(nudge, root.dataset.nudgeBest || ''); return; }
      var tpl = root.dataset.nudge || 'Order {qty}+ and pay {price} each{off}';
      var price = nx.each || '';
      var pm = /(\d+(?:[.,]\d+)?)\s*%/.exec(nx.off || '');
      var vIn = q('[data-dtf-fit-variant]');
      if (canOrder && pm && vIn && vIn.value) {
        var v = parse(root.dataset.dtfFitVariants, []).filter(function (x) { return String(x.id) === vIn.value; })[0];
        var base = v ? toNum(v.price) : null;
        // same per-unit round-down as checkout (see tierEachC in the engine)
        var bc = Math.round(base * 100);
        if (base != null) price = fmtLike(v.price, (bc - Math.floor(bc * parseFloat(pm[1].replace(',', '.')) / 100 + 1e-6)) / 100);
      }
      var html = tpl.replace('{qty}', '<b>' + nx.min + '</b>').replace('{price}', '<b>' + price + '</b>')
                           .replace('{off}', nx.off ? ' (' + nx.off + ')' : '');
      if (nudge.innerHTML !== html) nudge.innerHTML = html;
    }

    /* ---- custom size toggle ---- */
    if (customBtn && dims) customBtn.addEventListener('click', function () {
      var on = dims.hidden; dims.hidden = !on;
      customBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on && inW) inW.focus();
      sums(); status();
    });

    /* ---- wiring ---- */
    /* ---- size breakdown: chips show and hide rows ---- */
    var bdSumRow = q('[data-bstep-bd-sum]'), bdLine = q('[data-bstep-bd-line]');
    root.querySelectorAll('[data-bstep-bd-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var row = document.getElementById(chip.getAttribute('aria-controls'));
        if (!row) return;
        var inp = row.querySelector('[data-dtf-fit-bd]');
        var on = chip.getAttribute('aria-pressed') !== 'true';
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        row.hidden = !on;
        if (!inp) return;
        if (on) {
          if (!(parseInt(inp.value, 10) > 0)) inp.value = 1;
          inp.focus(); inp.select();
        } else {
          inp.value = 0;
        }
        // the engine totals and prices on input; bubbling reaches refresh() too
        inp.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
    function bdSummary() {
      if (!bdSumRow) return;
      var none = qty() === 0;
      if (bdSumRow.hidden !== none) bdSumRow.hidden = none;
      setText(bdLine, totalOut ? totalOut.textContent.trim() : '');
    }

    function refresh() { quote(); nudgeLine(); sums(); status(); bdSummary(); }
    root.addEventListener('input', refresh);
    root.addEventListener('change', refresh);
    /* Advance only once the engine has checked the upload. A flattened file
       stays on this step so its warning, and the Remove background button,
       are seen before the customer moves on; a check that could not run
       (clear is null) advances as it always did. */
    var advanceOnCheck = false;
    if (fileIn) fileIn.addEventListener('change', function () {
      advanceOnCheck = !!(fileIn.files && fileIn.files.length);
    });
    root.addEventListener('dtf:alpha', function (e) {
      if (!advanceOnCheck) return;
      advanceOnCheck = false;
      if (e.detail && e.detail.clear === false) return;
      setTimeout(function () { open(Math.min(at('art') + 1, steps.length - 1)); refresh(); }, 420);
    });
    // the engine writes the readout and flips the file row without events; watch those
    /* Only nodes the engine writes and this script never touches. Observing
       anything refresh() itself writes (the price line, the tier rows) turns
       every write into another callback — that loop hung the theme editor on
       10 Sep 2026. Writes below are also change-only, so a re-render that
       lands on the same value produces no mutation at all. */
    var scheduled = false;
    var mo = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () { scheduled = false; refresh(); });
    });
    [fileRow, oNote, oDpi, oSize, alphaOut].forEach(function (el) {
      if (el) mo.observe(el, { attributes: true, childList: true, characterData: true, subtree: true });
    });

    // let the engine run first, then compose
    setTimeout(refresh, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtf-sample-modal"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__dtfSampleBound) return;
  window.__dtfSampleBound = true;

  var OPEN_SEL = 'a[href*="/pages/sample-packs"], [data-dtf-sample-open]';

  function modal() { return document.querySelector('[data-dtf-sample-modal]'); }

  function open() {
    var m = modal();
    if (m && typeof m.showModal === 'function' && !m.open) {
      m.showModal();
      var first = m.querySelector('input, textarea, button');
      if (first) { try { first.focus(); } catch (e) {} }
    }
  }

  function close() {
    var m = modal();
    if (m && m.open) m.close();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(OPEN_SEL);
    if (trigger && modal()) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-dtf-sample-close]')) { e.preventDefault(); close(); return; }
    // Click on the dialog element itself (the backdrop area) closes it.
    var m = modal();
    if (m && m.open && e.target === m) close();
  });

  function init() {
    var m = modal();
    if (m && m.querySelector('[data-dtf-sample-posted]')) open();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Theme editor: let the merchant preview the modal when they select it.
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-dtf-sample-modal]')) open();
  });
  document.addEventListener('shopify:section:deselect', function () { close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-builder"] && !Shopify.designMode) return;
  try {
    
class HwGangSheetCalc {
  constructor(root) {
    this.root = root;
    this.rate = parseFloat(root.dataset.rate) || 0;
    this.vatPct = parseFloat(root.dataset.vat) || 0;
    this.currency = root.dataset.currency || 'ZAR';
    this.buttons = Array.from(root.querySelectorAll('.hw-build__size'));
    this.vatOut = root.querySelector('[data-hw-vat]');
    this.totalOut = root.querySelector('[data-hw-total]');
    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => this.select(btn));
    });
    const initial = this.buttons.find((b) => b.getAttribute('aria-pressed') === 'true') || this.buttons[0];
    if (initial) this.select(initial);
  }

  format(value) {
    try {
      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return value.toFixed(2);
    }
  }

  select(btn) {
    this.buttons.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
    const area = parseFloat(btn.dataset.area) || 0;
    const ex = area * this.rate;
    const vat = ex * (this.vatPct / 100);
    if (this.vatOut) this.vatOut.textContent = this.format(vat);
    if (this.totalOut) this.totalOut.textContent = this.format(ex + vat);
  }
}

function hwInitCalcs() {
  document.querySelectorAll('[data-hw-calc]').forEach((el) => {
    if (el.dataset.hwReady === 'true') return;
    el.dataset.hwReady = 'true';
    new HwGangSheetCalc(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hwInitCalcs);
} else {
  hwInitCalcs();
}
document.addEventListener('shopify:section:load', hwInitCalcs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Manual formatter. toLocaleString('en-ZA') renders 264.50 as "264,50",
     which fights the client's own "R1,121.25" convention everywhere else on
     the site. */
  function rand(n) {
    if (!isFinite(n)) { return ''; }
    var parts = Math.abs(n).toFixed(2).split('.');
    var whole = parts[0], out = '', c = 0;
    for (var i = whole.length - 1; i >= 0; i--) {
      out = whole[i] + out;
      if (++c % 3 === 0 && i > 0) { out = ',' + out; }
    }
    return (n < 0 ? '-R' : 'R') + out + '.' + parts[1];
  }

  function money(el, n) { el.textContent = rand(n); }

  function setup(root) {
    var sizeSel = root.querySelector('[data-hw-ord-size]');
    var qtyInput = root.querySelector('[data-hw-ord-qty]');
    var eachEl = root.querySelector('[data-hw-ord-each]');
    var totalEl = root.querySelector('[data-hw-ord-total]');
    var fileInput = root.querySelector('[data-hw-ord-file]');
    var fileName = root.querySelector('[data-hw-ord-filename]');
    var tierRows = Array.prototype.slice.call(root.querySelectorAll('[data-hw-ord-tier]'));
    var min = parseInt(root.getAttribute('data-min'), 10);
    var tiersActive = root.getAttribute('data-tiers-active') === '1';
    var hintDefault = fileName ? fileName.textContent : '';

    if (!isFinite(min) || min < 1) { min = 1; }

    function qty() {
      var v = parseInt(qtyInput ? qtyInput.value : '', 10);
      return (!isFinite(v) || v < min) ? min : v;
    }

    function basePrice() {
      if (!sizeSel) { return NaN; }
      var opt = sizeSel.options[sizeSel.selectedIndex];
      return opt ? parseFloat(opt.getAttribute('data-price')) : NaN;
    }

    /* Highest tier whose threshold the quantity has reached. The row is
       marked whatever happens, so the customer can see where they sit on the
       ladder — but it only moves the price when a Function is actually
       applying the break. */
    function tierFor(q) {
      var hit = null;
      tierRows.forEach(function (row) {
        var t = parseInt(row.getAttribute('data-min'), 10);
        if (isFinite(t) && q >= t && (!hit || t >= parseInt(hit.getAttribute('data-min'), 10))) {
          hit = row;
        }
      });
      return hit;
    }

    function draw() {
      var q = qty(), base = basePrice(), hit = tierFor(q), each = base;

      tierRows.forEach(function (row) {
        if (row === hit) { row.setAttribute('data-on', ''); }
        else { row.removeAttribute('data-on'); }
      });

      if (tiersActive && hit) {
        var tp = parseFloat(hit.getAttribute('data-price'));
        if (isFinite(tp)) { each = tp; }
      }

      if (eachEl) {
        eachEl.textContent = isFinite(each) ? rand(each) + ' each' : '';
      }
      if (totalEl) {
        if (isFinite(each)) { money(totalEl, each * q); }
        else { totalEl.textContent = ''; }
      }
    }

    if (sizeSel) { sizeSel.addEventListener('change', draw); }

    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        var digits = qtyInput.value.replace(/[^0-9]/g, '').slice(0, 5);
        if (digits !== qtyInput.value) { qtyInput.value = digits; }
        draw();
      });
      qtyInput.addEventListener('blur', function () {
        qtyInput.value = String(qty());
        draw();
      });
    }

    root.querySelectorAll('[data-hw-ord-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-hw-ord-step'), 10) || 0;
        var next = qty() + step;
        if (next < min) { next = min; }
        if (next > 99999) { next = 99999; }
        qtyInput.value = String(next);
        draw();
      });
    });

    if (fileInput && fileName) {
      fileInput.addEventListener('change', function () {
        var f = fileInput.files && fileInput.files[0];
        fileName.textContent = f ? f.name : hintDefault;
      });
    }

    draw();
  }

  function init() {
    document.querySelectorAll('[data-hw-ord]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
